// ------------------------------------------------------------------------------
export const cortarStrings = (string, tamaño) => {
  return string.length > tamaño
  ? string.substring(0, tamaño) + "..."
  : string;
}

// ------------------------------------------------------------------------------
export const horaActual = () =>{
  
  return new Date().getTime();
}